module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "schedule"
  }, [_c('AppSvgIcon', {
    staticClass: "svgIconCalendar",
    attrs: {
      "icon-name": _vm.$ui.IconSvgName.calendar
    }
  }), _c('p', [_vm._v(_vm._s(_vm.parseDate(_vm.scheduleFrom)) + " - " + _vm._s(_vm.parseDate(_vm.scheduleTo)))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54266c1c","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/catalog/list/item/components/ScheduleDate.vue
// module id = ddc9bea9acd1bd533885
// module chunks = 89